import { render } from "./Presentation.vue?vue&type=template&id=df0bf37a&ts=true"
import script from "./Presentation.vue?vue&type=script&lang=ts"
export * from "./Presentation.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__